
import { Component, Vue } from "vue-property-decorator";
import DContainerLayout from "@/views/base/DContainerLayout.vue";
import DList from "@/views/base/DList.vue";
import { getEnumMap, showConfirm, showError, showSuccess, showWarning } from "@/utils/Common";
import { API_PATENT_FOLLOW, API_PATENT_LIST, API_PATENT_REMOVE } from "@/configs/Apis";

@Component({
  components: { DList, DContainerLayout }
})
export default class UnfollowPatent extends Vue {
  hasSelectedItems = false;
  queryStr: string = JSON.stringify({ unfollow: true });

  onModuleRegistered() {
    this.createTableColumns();
  }

  get dataApi() {
    return API_PATENT_LIST;
  }

  createTableColumns() {
    const map = getEnumMap(this.$store.getters["enums/getEnumsByKey"]("PatentType"));
    const statusMap = getEnumMap(this.$store.getters["enums/getEnumsByKey"]("PatentStatus"));
    const columns: Array<TableColumnOption> = [
      { prop: "patentNo", display: "专利号", width: 200 },
      { prop: "appDate", display: "申请日", width: 200 },
      { prop: "title", display: "专利名称", width: 200 },
      {
        prop: "patentType",
        display: "专利类型",
        width: 200,
        formatter: (data: any, column: any, value: any) => {
          return `<div class="patent_type ${value} ">${map.get(value)}</div>`;
        }
      },
      { prop: "patentee", display: "专利权人", width: 200 },
      { prop: "applicants", display: "申请人", width: 200 },
      { prop: "inventors", display: "发明人", width: 200 },
      { prop: "agencyName", display: "代理机构", width: 200 },
      { prop: "patentStatus", display: "法律状态", width: 200 }
    ];
    this.$store.dispatch("unfollowpatent/setColumns", columns);
  }

  onSelectionChanged(rows: Array<any>) {
    this.hasSelectedItems = rows && rows.length > 0;
  }

  refollow(cmd: string) {
    let selectedRows: Array<string> = ["ALL"];
    let message = "是否重新监控<span style='color:red;font-weight: 600'>全部</span>专利?";
    if (cmd === "selected") {
      selectedRows = (this.$refs.monitorgrid as any).getSelectedRows();
      if (!selectedRows.length) {
        showWarning("请至少选择一条数据");
        return;
      }
      message = "是否重新监控选择的专利?";
    }
    showConfirm(message)
      .then(() => {
        this.$store.dispatch("unfollowpatent/post", {
          api: API_PATENT_FOLLOW,
          params: JSON.stringify(selectedRows)
        }).then(() => showSuccess("重新监控成功"))
          .then(() => { this.searchData(); this.$emit("load-tree"); })
          .catch(({ message }) => showError(message));
      }).catch(() => "");
  }

  remove(cmd: string) {
    if (cmd === "clear") {
      this.clearPatentData();
    } else {
      const selectedRows: Array<string> = (this.$refs.monitorgrid as any).getSelectedRows();
      if (!selectedRows.length) {
        showWarning("请至少选择一条数据");
        return;
      }
      showConfirm("是否彻底删除选择的专利?")
        .then(() => {
          this.$store.dispatch("unfollowpatent/post", {
            api: API_PATENT_REMOVE,
            params: JSON.stringify(selectedRows)
          }).then(() => showSuccess("彻底删除完成"))
            .then(() => { this.searchData(); this.$emit("load-tree"); })
            .catch(({ message }) => showError(message));
        }).catch(() => "");
    }
  }

  clearPatentData() {
    showConfirm("是否清空回收站?")
      .then(() => {
        this.$store.dispatch("unfollowpatent/post", {
          api: API_PATENT_REMOVE,
          params: JSON.stringify(["clearAll"])
        }).then(() => showSuccess("彻底删除完成"))
          .then(() => { this.searchData(); this.$emit("load-tree"); })
          .catch(({ message }) => showError(message));
      }).catch(() => "");
  }

  searchData() {
    this.queryStr += " ";
  }
}
